import React from 'react';
import { ListColumnType, ListFilterFieldType, ListMoreMenuConfig } from 'types/ListTypes';
import { BulkActionsConfig } from 'types/BulkActionTypes';
import AbstractList from 'components/lists/AbstractList';
import LocationForm from './LocationForm';

// Enable the bulk actions panel for this list
const locationBulkActions: BulkActionsConfig = {
    objectKey: 'location',
    deleteOrDeactivate: 'delete',
    showExport: true,
};

// Configure the more menu of this list
const locationMoreMenu: ListMoreMenuConfig = {
    inactiveItemsToggle: {
        semantic: 'deleted',
        activeParams: { deleted: true },
    },
};

// Set the filter fields of this list
const locationFilterFields: ListFilterFieldType[] = [
    {
        type: 'search',
        name: 'search',
        label: 'forms.search_label',
        placeholder: 'forms.search_placeholder',
        queryParam: 'search',
        width: 1.5
    },
    {
        type: 'text',
        name: 'street',
        label: 'location.general.street_label',
        placeholder: 'location.general.street_filter_placeholder',
        queryParam: 'street',
        width: 1.25
    },
    {
        type: 'text',
        name: 'postal_code',
        label: 'location.general.postal_code_label',
        placeholder: 'location.general.postal_code_label',
        queryParam: 'postal_code',
        width: 1
    },
    {
        type: 'text',
        name: 'city',
        label: 'location.general.city_label',
        placeholder: 'location.general.city_label',
        queryParam: 'city',
        width: 1.25
    }
];

// Rename the name of the function:
const LocationList: React.FC = () => {

    // Specify the options of this list:
    const query = {
        endpoint: 'get_location_list',
        defaultParams: { 'deleted': false },
        object: 'location'
    }
    const objectName = 'location.general.object_name'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = true

    // Specify form, detail modal or detailpage for this list
    const formModal = <LocationForm />;
    const modalSize = 'add-form';
    const onRowClick = 'detailPage'
    const detailPageUrl = 'contacts/work-locations'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'address', label: 'location.general.address_label' },
    ];

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            columns={columns}
            filterFields={locationFilterFields}
            formModal={formModal}
            modalSize={modalSize}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
            detailPageUrl={detailPageUrl}
            bulkActions={locationBulkActions}
            moreMenu={locationMoreMenu}
        />
    );
};

export default LocationList;